import { render, staticRenderFns } from "./buy-dialog.vue?vue&type=template&id=1da636ca&scoped=true"
import script from "./buy-dialog.vue?vue&type=script&lang=js"
export * from "./buy-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da636ca",
  null
  
)

export default component.exports